/**
 * 字段多语言应用 mixin
 * 根据当前选择的语言（store.state.i18n.currentLang）覆盖字段和选项的 displayName
 * 语言切换时自动重新应用
 */
export default {
  watch: {
    "$store.state.i18n.currentLang"() {
      this.applyI18n(this.formInfo);
    },
  },
  methods: {
    applyI18n(formInfo) {
      if (!formInfo || !formInfo.items || !formInfo.items.length) return;
      const lang = this.$store.state.i18n.currentLang;
      const langKey = lang.toLowerCase();
      if (lang === "zh_CN") return;
      formInfo.items.forEach((item) => {
        if (item.i18n && (item.i18n[lang] || item.i18n[langKey])) {
          item.displayName = item.i18n[lang] || item.i18n[langKey];
        }
        const i18n = item.i18n || {};
        const privacyKey = "privacyPolicyText_" + lang;
        const privacyKeyLower = "privacyPolicyText_" + langKey;
        if (i18n[privacyKey] || i18n[privacyKeyLower]) {
          item.privacyPolicyText = i18n[privacyKey] || i18n[privacyKeyLower];
          item.privacyPolicyTitle = i18n[privacyKey] || i18n[privacyKeyLower];
        }
        this._translateItemList(item, lang, langKey);
        // DICT 字段：CDN Select 异步加载数据后会替换 listOptions，需要 watcher 重新翻译
        if (item.listOptionType === "DICT" && !item._i18nWatched) {
          item._i18nWatched = true;
          const self = this;
          this.$watch(
            function () {
              return item.listOptions && item.listOptions.length;
            },
            function () {
              self._translateItemList(item, lang, langKey);
            }
          );
        }
      });
    },
    _translateItemList(item, lang, langKey) {
      if (!Array.isArray(item.listOptions)) return;
      console.log(
        "[i18n-debug] _translateItemList: field=" +
          item.fieldName +
          " listOptionType=" +
          item.listOptionType +
          " opts=" +
          item.listOptions.length
      );
      item.listOptions.forEach((opt, i) => {
        var src = opt.i18n ? opt.i18n[lang] || opt.i18n[langKey] : null;
        console.log(
          "[i18n-debug]   lang=" +
            lang +
            " langKey=" +
            langKey +
            " i18nKeys=" +
            (opt.i18n ? Object.keys(opt.i18n).join(",") : "N/A")
        );
        console.log(
          "[i18n-debug]   opt[" +
            i +
            "] optionValue=" +
            opt.optionValue +
            " optionLabel=" +
            opt.optionLabel +
            " hasI18n=" +
            !!opt.i18n +
            " translated=" +
            (src || "none")
        );
        if (src) {
          opt.optionLabel = src;
        }
      });
    },
  },
};
